import {
    BaseQueryFn,
    FetchArgs,
    fetchBaseQuery,
    FetchBaseQueryError,
    FetchBaseQueryMeta,
} from "@reduxjs/toolkit/query";
import { RootState } from "../../app/store";

export function apiBaseQuery(): BaseQueryFn<
    string | FetchArgs,
    unknown,
    FetchBaseQueryError,
    object,
    FetchBaseQueryMeta
> {
    return fetchBaseQuery({
        baseUrl: import.meta.env.VITE_ADMIN_URL,
        prepareHeaders: (headers, { getState }) => {
            const { root } = getState() as RootState;
            const { authToken } = root;
            if (authToken) {
                headers.set("Authorization", `Bearer ${authToken}`);
            }
            headers.set("Content-Type", "application/json");
            headers.set("Accept", "application/json");
            return headers;
        },
    });
}
